import { BuyUpPending } from 'pages/BuyUpPending/BuyUpPending';

export default BuyUpPending;
